(ns client-portal.client.voice-insights.ces.data
  (:require [client-portal.client.core.data :as core.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.concepts.data :as concepts.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:voice-insights :ces])
(def charts-path (conj root-path :charts))
(def charts-data-path (conj charts-path :data))

(re/reg-event-db
  :vi-ces/initialize-filters re/middleware
  (fn [db]
    (core.d/initialize-common-filters db)))

(re/reg-event-db
  :vi-ces/reload re/middleware
  (fn [db]
    (-> db
        (assoc-in charts-data-path nil))))

(re/reg-event-fx
  :vi-ces/initialize re/middleware
  (fn [{:keys [db]}]
    (re/dispatch [:vi-ces/initialize-filters])
    (re/dispatch [:vi-ces/reload])
    {:db db
     :forward-events {:register :vi-ces-initialization-listener
                      :events #{:concepts/select :locations/select :core/select-crew-type
                                :core/select-timeframe :locations/clear-selected
                                :core/timeframe-date-range-changed}
                      :dispatch-to [:vi-ces/reload]}}))

(defn gen-ces-pie-data [d]
  (let [ces-groups [{:group "Undetermined"
                     :color "#C4C4C4"
                     :vals #{nil}}
                    {:group "Poor (High Effort)"
                     :color "#64D2E8"
                     :vals #{"1" "2" "3"}}
                    {:group "Good (Moderate Effort)"
                     :color "#6DD9BD"
                     :vals #{"4" "5"}}
                    {:group "Excellent (Low Effort)"
                     :color "#A68CC5"
                     :vals #{"6" "7"}}]
        sorted-d (->> d
                      (sort-by #(util/parse-int (or (:value %) 0)))
                      (reverse))]
    {:inner-data (mapv (fn [{:keys [group color vals] :as r}]
                         {:name group
                          :value (->> d
                                      (filter #(contains? vals (:value %)))
                                      (map :count)
                                      (apply +))
                          :fill color
                          :raw r})
                       (reverse ces-groups))
     :outer-data (mapv (fn [{:keys [value] :as r}]
                         (let [ces-group (->> ces-groups
                                              (filter #(contains? (:vals %) value))
                                              (first))
                               vals-ints (mapv #(when % (util/parse-int %)) (:vals ces-group))]
                           (cond-> {:name (or value "N/A")
                                    :value (:count r)
                                    :fill (:color ces-group)
                                    :opacity (if (<= (count vals-ints) 1)
                                               0.8
                                               (- 0.8 (* (- (apply max vals-ints) (util/parse-int (or value 0))) 0.1)))
                                    :raw r}
                                   (not value)
                                   (assoc :label-override "N/A"))))
                       sorted-d)}))

(defn transf-charts-data [d]
  (-> d
      (update :ces-counts-by-value gen-ces-pie-data)))

(re/reg-auth0-loader
  :vi-ces/load-charts-data
  charts-data-path
  (fn [db _]
    (when (concepts.d/current-concept-id db)
      {:method :post
       :url "/api/vi/ces/charts"
       :json-params (vi.d/base-query-args db {})}))
  :transf #(or (some-> % :body (util/->kebab-case-keywords) (transf-charts-data)) [])
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :vi-ces/charts-data-
  charts-data-path
  :vi-ces/load-charts-data)
